<template>
  <div class="pad30" v-if="loaded">
    <h2 class="f18 fb normal gray_2">客户列表</h2>
    <div class="box20"></div>
    <div class="flex flex-wrap flex1 items-center mar20-b">
      <div>
        <el-input class="w150 mar20_r" placeholder="请输入客户名称" v-model.trim="customerName"></el-input>
      </div>
      <div>
        <el-input class="w150 mar20_r" placeholder="请输入客户手机号" v-model.trim="customerPhone"></el-input>
      </div>
      <div>
        <el-select class="w150 mar20_r" v-model="groupId" filterable clearable placeholder="请选择客户分组">
          <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <el-button @click="(customerName = ''), (customerPhone = ''), (groupId = '')">重置</el-button>

      <el-button type="primary" @click="getCustomerList">查询</el-button>

      <el-button type="primary" class="mar-20-l" @click="initial">新增个人客户</el-button>

      <el-button type="primary" class="mar-15-l" @click="initialOrg">新增企业客户</el-button>
    </div>
    <el-table :data="customerList" @selection-change="customerSelect" row-key="targetId" style="width: 100%">
      <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
      <el-table-column show-overflow-tooltip prop="customerName" label="客户名称" />
      <el-table-column prop="phone" label="客户手机号" />
      <el-table-column prop="" label="分组名称">
        <template slot-scope="scope">
          <span>{{ scope.row.groupName }}</span>
          <i class="el-icon-edit-outline f20 mar5_r pointer" @click="(groupEditVisible = true), thisCheckCustomer(scope.row)"></i>
        </template>
      </el-table-column>
      <el-table-column label="身份">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">个人</span>
          <span v-if="scope.row.type == 2">企业</span>
        </template>
      </el-table-column>
      <el-table-column label="服务人员">
        <template slot-scope="scope">
          <span v-if="scope.row.serviceName">{{ scope.row.serviceName }}</span>
          <span v-else>暂无</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="240">
        <template slot-scope="scope">
          <el-button type="primary" @click="editCustomer(scope.row)">编辑</el-button>
          <el-button type="primary" class="mar15-l" @click="deleteCustomer(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex items-center mar20-t">
      <el-button type="primary" :disabled="this.multipleSelection.length == 0" @click="deleteCustomerList">删除客户 </el-button>
      <div class="gray9 flex-auto mar-20-l">共 {{ pageTotal }} 条记录 第 {{ pageNum }} / {{ totalPage }} 页</div>
      <el-pagination
        layout="prev, pager, next, sizes, jumper"
        background
        hide-on-single-page
        :page-size.sync="pageSize"
        :page-count="totalPage"
        :current-page.sync="pageNum"
        :page-sizes="[6, 10, 20]"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
    <template>
      <el-dialog title="全部分组" :visible.sync="groupEditVisible" width="500px">
        <div class="flex flex-wrap">
          <template v-for="item in groupList">
            <div
              class="mar15-r mar15-b pad5-tb pad10-lr group pointer"
              :key="item.id"
              @click="checkGroup(item.id)"
              :class="{ group_check: thisCustomer.groupId == item.id }"
            >
              {{ item.name }}
            </div>
          </template>
        </div>
        <div class="flex items-center justify-center pad20-t">
          <el-button @click="groupEditVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitGroup" :loading="confirmLoading">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="编辑客户" :visible.sync="dialogEditVisible">
        <el-form :model="editCustomerForm">
          <el-form-item label="客户名称" :label-width="formLabelWidth">
            <el-input v-model="editCustomerForm.customerName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" :label-width="formLabelWidth">
            <el-input v-model="editCustomerForm.phone" :disabled="true" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="服务人员" :label-width="formLabelWidth">
            <el-select v-model="editCustomerForm.serviceBoId" filterable clearable placeholder="请选择服务人员">
              <el-option v-for="item in serviceList" :key="item.boId" :label="item.boName + '-' + item.mobilePhoneCn" :value="item.boId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户分组" :label-width="formLabelWidth">
            <el-select v-model="editCustomerForm.groupId" filterable placeholder="请选择客户分组">
              <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="(dialogEditVisible = false), (editCustomerForm = {})">取 消</el-button>
          <el-button type="primary" @click="submitCustomerForm" :loading="confirmLoading">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="添加客户" :visible.sync="dialogAddVisible" width="850px">
        <el-form :model="addCustomerForm" label-suffix=" : ">
          <el-alert title="" type="success" :closable="false" show-icon>
            <template slot="title">
              <div>温馨提示：开启自动创建客户档案功能，用户下单后自动创建客户档案 <span class="pointer mar10-l fb" @click="toShopFunction">去设置</span></div>
            </template>
          </el-alert>
          <div class="box10"></div>
          <el-form-item label="客户分组">
            <el-select v-model="addCustomerForm.groupId" filterable placeholder="请选择客户分组">
              <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form v-for="(customer, index) in addCustomerForm.customerList" :model="customer" :inline="true" class="demo-form-inline" :key="index">
            <el-form-item label="" style="margin-bottom: 5px">
              <el-input v-model="customer.customerPhone" type="number" maxlength="11" placeholder="请输入客户手机号" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="" style="margin-bottom: 5px">
              <el-input v-model="customer.customerName" placeholder="请输入客户名称" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="" style="margin-bottom: 5px">
              <el-select v-model="customer.serviceBoId" filterable clearable placeholder="请选择服务人员">
                <el-option v-for="item in serviceList" :key="item.boId" :label="item.boName + '-' + item.mobilePhoneCn" :value="item.boId"></el-option>
              </el-select>
            </el-form-item>
            <i class="el-icon-remove f24 mar5_r pointer mar5-t" @click="delCustomer(customer, index)"></i>
          </el-form>
          <div>
            <el-button type="primary" @click="addRow(1)">新增</el-button>
            <el-button type="primary" @click="addRow(3)">新增多行</el-button>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogAddVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitCustomerFormAdd" :loading="confirmLoading">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="添加客户" :visible.sync="dialogAddOrgVisible" width="850px">
        <el-form :model="addCustomerForm" label-suffix=" : ">
          <el-alert title="" type="success" :closable="false" show-icon>
            <template slot="title">
              <div>温馨提示：开启自动创建客户档案功能，用户下单后自动创建客户档案 <span class="pointer mar10-l fb" @click="toShopFunction">去设置</span></div>
            </template>
          </el-alert>
          <div class="box10"></div>
          <el-form-item label="客户分组">
            <el-select v-model="addCustomerForm.groupId" filterable placeholder="请选择客户分组">
              <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-table :data="addCustomerForm.customerList" style="width: 100%">
            <el-table-column show-overflow-tooltip prop="customerName" label="企业名称" />
            <el-table-column prop="adminName" label="管理员名称" />
            <el-table-column label="认证状态">
              <template slot-scope="scope">
                <span v-if="scope.row.state == 8">已认证</span>
                <span v-if="scope.row.state != 8">未认证</span>
              </template>
            </el-table-column>
            <el-table-column label="服务人员">
              <template slot-scope="scope">
                <el-select v-model="scope.row.serviceBoId" filterable clearable placeholder="请选择服务人员">
                  <el-option v-for="item in serviceList" :key="item.boId" :label="item.boName + '-' + item.mobilePhoneCn" :value="item.boId"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="primary" class="mar15-l" @click="delCustomer(scope.row, scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="mar20-t">
            <el-button type="primary" @click="(dialogOrgVisible = true), (orgName = ''), (seachOrgList = [])">新增</el-button>
          </div>
          <el-dialog title="企业列表" :visible.sync="dialogOrgVisible" width="700px" append-to-body>
            <div>
              <el-input class="w210 mar20_r" placeholder="请输入企业全称" v-model.trim="orgName"></el-input>
              <el-button @click="orgName = ''">重置</el-button>
              <el-button class="mar-15-l" type="primary" @click="queryOrgList()">查询</el-button>
            </div>
            <el-table :data="seachOrgList" @selection-change="orgSelect" row-key="id" style="width: 100%">
              <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
              <el-table-column show-overflow-tooltip prop="name" label="企业名称" />
              <el-table-column prop="adminName" label="管理员名称" />
              <el-table-column label="认证状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.state == 8">已认证</span>
                  <span v-if="scope.row.state != 8">未认证</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="primary" @click="confirmOrg(scope.row)">确 定</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
              <el-button @click="(dialogOrgVisible = false), (seachOrgList = [])">取 消</el-button>
              <el-button type="primary" @click="confirmOrgList">确 定</el-button>
            </div>
          </el-dialog>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogAddOrgVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitCustomerFormAdd" :loading="confirmLoading">确 定</el-button>
        </div>
      </el-dialog>
    </template>
  </div>
  <div style="min-height: 900px" v-else></div>
</template>

<script>
import { mapState } from "vuex";
import requestApi from "@/utils/requestApi";
import { Loading } from "element-ui";

export default {
  data() {
    return {
      loaded: false,
      env: process.env,
      groupList: [],
      customerList: [],
      serviceList: [],
      multipleSelection: [],
      orgMultipleSelection: [],
      // 搜索
      groupId: "",
      customerName: "",
      customerPhone: "",
      pageSize: 10,
      pageNum: 1,
      // 店铺信息
      shop: {},

      totalPage: 10,
      pageTotal: 0,

      dialogEditVisible: false,
      formLabelWidth: "120px",

      editCustomerForm: {},
      groupEditVisible: false,

      thisCustomer: {},

      dialogAddVisible: false,
      dialogAddOrgVisible: false,
      addCustomerForm: {
        customerList: [],
      },

      seachOrgList: [],
      dialogOrgVisible: false,
      orgName: "",

      confirmLoading: false,
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.getCustomerList();
  },
  methods: {
    toShopFunction() {
      if (self != top) {
        window.parent.postMessage(
          { fn: "open", data: { url: `${process.env.VUE_APP_APP}v/mj/shop/setting?appid=1&isShowTitle=1`, title: "系统设置", target: 0 } },
          "*"
        );
      } else {
        window.open(`${process.env.VUE_APP_APP}v/mj/shop/setting?appid=1&isShowTitle=1`);
      }
    },
    initial() {
      this.addCustomerForm = {
        groupId: this.groupList && this.groupList.length > 0 ? this.groupList[0].id : "",
        type: 1,
        customerList: [],
      };
      this.addRow(3);
      this.dialogAddVisible = true;
    },
    initialOrg() {
      this.addCustomerForm = {
        groupId: this.groupList && this.groupList.length > 0 ? this.groupList[0].id : "",
        type: 2,
        customerList: [],
      };
      this.dialogAddOrgVisible = true;
    },
    getCustomerList() {
      let loadingInstance1 = Loading.service({ fullscreen: true });
      requestApi.post(`${process.env.VUE_APP_APITAAS}sctrading/shop/mj/info`, {}).then((res) => {
        this.shop = res.data;
        this.getGroupList();
        this.getServiceList();
        requestApi
          .post(`${process.env.VUE_APP_APITAAS}scbasic/mj/member/customergroupmember/selListByPage`, {
            customerName: this.customerName,
            customerPhone: this.customerPhone,
            groupId: this.groupId,
            pageSize: this.pageSize,
            pageNum: this.pageNum,
          })
          .then((res) => {
            this.pageTotal = res.data.total;
            this.customerList = res.data.list;
            this.totalPage = res.data.pages;
            this.loaded = true;
            loadingInstance1.close();
          });
      });
    },
    // 修改每页显示个数
    sizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getCustomerList();
    },

    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.getCustomerList();
    },
    getGroupList() {
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}scbasic/member/customergroup/selList`, {
          name: "",
          shopId: 1001,
        })
        .then((res) => {
          this.groupList = res.data || [];
        });
    },
    getServiceList() {
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/shop/shopstaff/selListByPage`, {
          pageNum: 1,
          pageSize: 1000,
        })
        .then((res) => {
          this.serviceList = res.data.list;
          const data = {
            boId: "0",
            boName: "请选择服务人员",
            mobilePhoneCn: "",
          };
          this.serviceList.unshift(data);
        });
    },
    editCustomer(item) {
      this.dialogEditVisible = true;
      this.editCustomerForm = JSON.parse(JSON.stringify(item));
    },
    submitCustomerForm() {
      if (!this.editCustomerForm.customerName || this.editCustomerForm.customerName == "") {
        this.$message.error("请输入客户名称");
        return;
      }
      this.confirmLoading = true;
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}scbasic/mj/member/customergroupmember/editCustomer`, {
          archivesId: this.editCustomerForm.archivesId,
          targetId: this.editCustomerForm.targetId,
          groupId: this.editCustomerForm.groupId,
          serviceBoId: this.editCustomerForm.serviceBoId || 0,
          customerName: this.editCustomerForm.customerName,
          sourceId: this.editCustomerForm.sourceId,
        })
        .then((res) => {
          if (res.code === "0") {
            this.dialogEditVisible = false;
            this.editCustomerForm = {};
            this.pageNum = 1;
            this.getCustomerList();
          } else {
            this.$message.error(res.msg);
          }
          this.confirmLoading = false;
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
    thisCheckCustomer(item) {
      this.thisCustomer = {
        archivesId: item.archivesId,
        targetId: item.targetId,
        groupId: item.groupId,
        oldGroupId: item.groupId,
      };
    },
    checkGroup(id) {
      this.thisCustomer.groupId = id;
    },
    submitGroup() {
      this.confirmLoading = true;
      console.log(this.thisCustomer.groupId == this.thisCustomer.oldGroupId);
      if (this.thisCustomer.groupId == this.thisCustomer.oldGroupId) {
        this.groupEditVisible = false;
        return;
      }
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}scbasic/mj/member/customergroupmember/editCustomerGroup`, {
          archivesId: this.thisCustomer.archivesId,
          targetId: this.thisCustomer.targetId,
          groupId: this.thisCustomer.groupId,
          oldGroupId: this.thisCustomer.oldGroupId,
        })
        .then((res) => {
          if (res.code === "0") {
            this.groupEditVisible = false;
            this.thisCustomer = {};
            this.pageNum = 1;
            this.getCustomerList();
          } else {
            this.$message.error(res.msg);
          }
          this.confirmLoading = false;
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },

    customerSelect(val) {
      console.log("val", val);
      this.multipleSelection = val || [];
    },
    deleteCustomer(item) {
      this.$confirm("您是否要删除当前所选客户:" + item.customerName, "提示").then(() => {
        requestApi
          .post(`${process.env.VUE_APP_APITAAS}scbasic/mj/member/customergroupmember/delCustomer`, {
            archivesId: item.archivesId,
            targetId: item.targetId,
            sourceId: item.sourceId,
          })
          .then((res) => {
            if (res.code == "0") {
              this.$message.success("删除成功");
              this.pageNum = 1;
              this.getCustomerList();
            } else {
              this.$message.error(res.msg);
            }
          });
      });
    },
    deleteCustomerList() {
      if (this.multipleSelection.length == 0) {
        this.$message.info("请选择客户");
        return;
      }
      let customerMemberList = [];
      let nameList = [];
      this.multipleSelection.forEach(function (item) {
        const data = {
          archivesId: item.archivesId,
          targetId: item.targetId,
          sourceId: item.sourceId,
        };
        nameList.push(item.customerName);
        customerMemberList.push(data);
      });
      this.$confirm("您是否要删除当前所选客户：" + nameList.toString(), "提示").then(() => {
        requestApi
          .post(`${process.env.VUE_APP_APITAAS}scbasic/mj/member/customergroupmember/delCustomer`, {
            customerGroupMemberBoList: customerMemberList,
          })
          .then((res) => {
            if (res.code == "0") {
              this.$message.success("删除成功");
              this.pageNum = 1;
              this.getCustomerList();
            } else {
              this.$message.error(res.msg);
            }
          });
      });
    },

    addRow(num) {
      for (let i = 0; i < num; i++) {
        const data = {
          customerPhone: "",
          customerName: "",
          serviceBoId: "",
          customerId: "",
        };
        this.addCustomerForm.customerList.push(data);
      }
    },
    // 查询组织列表
    queryOrgList() {
      if (this.orgName !== "") {
        const param = {
          open_req_src: "nxmall_agr",
          name: this.orgName,
        };
        setTimeout(() => {
          this.$store.dispatch("shop/shop/getOrgList", param).then((res) => {
            this.seachOrgList = res.data.filter((item) => {
              return !item.group && item.name.toLowerCase().indexOf(this.orgName.toLowerCase()) > -1;
            });
          });
        }, 500);
      } else {
        this.$message.info("请输入企业名称");
        this.seachOrgList = [];
        return;
      }
    },
    orgSelect(val) {
      console.log("val", val);
      this.orgMultipleSelection = val || [];
    },
    confirmOrg(item) {
      const attr = this.addCustomerForm.customerList.filter((item) => item.customerId == item.id);
      if (attr.length == 0) {
        const data = {
          customerPhone: "",
          customerName: item.name,
          serviceBoId: "",
          customerId: item.id,
          adminName: item.adminName,
          state: item.state,
        };
        this.addCustomerForm.customerList.push(data);
      }
      this.seachOrgList = [];
      this.dialogOrgVisible = false;
    },
    confirmOrgList() {
      if (this.orgMultipleSelection.length == 0) {
        this.$message.info("请选择企业");
        return;
      }
      console.log("this.addCustomerForm", this.addCustomerForm);
      let attrList = this.addCustomerForm.customerList;
      this.orgMultipleSelection.forEach(function (item) {
        const attr = attrList.filter((e) => e.customerId == item.id);
        if (attr.length == 0) {
          const data = {
            customerPhone: "",
            customerName: item.name,
            serviceBoId: "",
            customerId: item.id,
            adminName: item.adminName,
            state: item.state,
          };
          attrList.push(data);
        }
      });
      this.addCustomerForm.customerList = attrList;
      this.orgMultipleSelection = [];
      this.seachOrgList = [];
      this.dialogOrgVisible = false;
    },
    delCustomer(item, index) {
      this.addCustomerForm.customerList.splice(index, 1);
    },
    submitCustomerFormAdd() {
      if (this.addCustomerForm.groupId == "") {
        this.$message.error("请选择客户分组");
        return;
      }
      // console.log("this.addCustomerForm.customerName", this.addCustomerForm.customerName);
      // if (!this.addCustomerForm.customerName || this.addCustomerForm.customerName == "") {
      //   this.$message.error("请输入客户名称");
      //   return;
      // }
      if (this.addCustomerForm.customerList.length == 0) {
        this.$message.error("请添加客户");
        return;
      }
      let customerMemberList = [];
      let addCustomerForm = this.addCustomerForm;
      let customerList = this.addCustomerForm.customerList;
      if (customerList.some((item) => !item.customerName && item.customerPhone)) {
        this.$message.error("请输入客户名称");
        return;
      }
      if (this.addCustomerForm.type == 1) {
        customerList.forEach(function (item) {
          if (item.customerPhone) {
            const data = {
              type: addCustomerForm.type,
              groupId: addCustomerForm.groupId,
              serviceBoId: item.serviceBoId || 0,
              customerPhone: item.customerPhone,
              customerName: item.customerName,
            };
            customerMemberList.push(data);
          }
        });
      } else if (this.addCustomerForm.type == 2) {
        customerList.forEach(function (item) {
          if (item.customerId) {
            const data = {
              customerId: item.customerId,
              serviceBoId: item.serviceBoId || 0,
              type: addCustomerForm.type,
              groupId: addCustomerForm.groupId,
              customerName: item.customerName,
            };
            customerMemberList.push(data);
          }
        });
      }
      if (customerMemberList.length == 0) {
        this.$message.error("请添加客户");
        return;
      }
      const reg = /^1\d{10}$/;
      const phoneList = customerMemberList
        .filter((item) => item.customerPhone && (item.customerPhone.length !== 11 || !reg.test(item.customerPhone)))
        .map((item) => item.customerPhone);
      if (phoneList.length > 0) {
        this.$message.error("客户手机号格式有误");
        return;
      }
      const telList = customerMemberList.filter((item) => item.customerPhone).map((item) => item.customerPhone);
      const isRepeat = telList.some((item, index, arr) => arr.indexOf(item) !== index);
      if (isRepeat) {
        this.$message.error("客户手机号重复");
        return;
      }
      this.confirmLoading = true;
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}scbasic/mj/member/customergroupmember/addCustomer`, {
          customerGroupMemberBoList: customerMemberList,
        })
        .then((res) => {
          if (res.code == "0") {
            this.$message.success("添加成功");
            this.pageNum = 1;
            this.getCustomerList();
            this.dialogAddVisible = false;
            this.dialogAddOrgVisible = false;
          } else {
            this.$message.error(res.msg);
          }
          this.confirmLoading = false;
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "list.scss";
</style>

<style>
.el-button--primary:hover,
.el-button--primary:focus {
  background: #0095f1;
  border-color: #0095f1;
  color: #ffffff;
}

.el-button--primary:active {
  background: #0095f1;
  border-color: #0095f1;
  color: #ffffff;
  outline: none;
}

.el-button--primary {
  color: #ffffff;
  background-color: #0095f1;
  border-color: #0095f1;
}

.el-button:active {
  color: #ffffff;
  outline: none;
}

.el-message-box .el-button:active {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-message-box .el-button:hover,
.el-message-box .el-button:focus {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-button--primary.is-disabled,
.el-button--primary.is-disabled:hover,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:active {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-select-dropdown__item.selected {
  color: #0095f1;
  font-weight: bold;
}
</style>
